import React from "react";
import Select from "react-select";
import CustomDatePicker from "../../components/CustomDatePicker";
import {customStyles} from "../../global/customStyles";
import moment from "moment";

const DateSelector = (
    {
        tab,
        translations,
        projectOptions,
        setReportId,
        selectedDate,
        reportDates,
        setSelectedDate,
        setSelectedItem,
        onScrollToBottom,
        isLoadingMore,
        onProjectSearch,
    }) => {

    const handleChangeDate = (date) => {
        setSelectedDate(date);
        setReportId(
            reportDates?.filter(
                (el) => {
                    return moment(el?.label, "DD/MM/YYYY").format("DD/MM/YYYY") ===
                        moment(date, "DD/MM/YYYY", true)?.format("DD/MM/YYYY")
                }
            )[0]
        );
    };


    return (
        <div className="s-page__selects">
            <div className="s-page__project">
                <p>
                    {
                        tab === 1 ? translations?.['project_reports.index.titles.project'] :
                            tab === 2 ? translations?.['quarterly_reports.index.titles.report'] :
                                translations?.['procurement_reports.index.titles.package']
                    }
                </p>
                <Select
                    options={projectOptions}
                    styles={{
                        ...customStyles,
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    key={tab}
                    id={tab}
                    isSearchable={true}
                    placeholder={
                        tab === 1 ?
                            translations?.['project_reports.index.placeholder.select_project'] :
                            tab === 2 ?
                                translations?.['quarterly_reports.index.placeholder.select_report'] :
                                translations?.['procurement_reports.index.placeholder.select_package']
                    }
                    isClearable={true}
                    onChange={(selected) => {
                        setSelectedItem(selected ?? {});
                        setSelectedDate(null);
                        if (!selected && tab === 1) {
                            onProjectSearch?.("");
                        }
                    }}
                    onMenuScrollToBottom={tab === 1 ? onScrollToBottom : undefined}
                    onInputChange={tab === 1
                        ? (value, { action }) => {
                            if (action === "input-change") onProjectSearch?.(value);
                        }
                        : undefined
                    }
                    filterOption={() => true}
                    isLoading={tab === 1 && isLoadingMore}
                />
            </div>
            <div className="s-page__project reporting-select">
                <p>
                    {
                        tab === 1 ? translations?.['project_reports.index.titles.report_month'] :
                            tab === 2 ? translations?.['quarterly_reports.index.titles.report_date'] :
                                translations?.['procurement_reports.index.titles.submitted_month']
                    }
                </p>
                {tab !== 2 &&
                    <CustomDatePicker
                        selected={selectedDate && moment(selectedDate, 'DD/MM/YYYY', true).isValid()
                            ? moment(selectedDate, 'DD/MM/YYYY').toDate()
                            : null}
                        placeholderText={
                            tab === 1 ?
                                translations?.['project_reports.index.placeholder.click_to_select_a_date'] :
                                translations?.['procurement_reports.index.placeholder.choose_month']
                        }
                        onChange={(date) => handleChangeDate(date)}
                        dateFormat="MMMM yyyy"
                        includeDates={reportDates?.map((el) => {
                            const parsedDate = moment(el?.label, 'DD/MM/YYYY');
                            return parsedDate.isValid() ? parsedDate.toDate() : null;
                        }).filter(date => date !== null)}
                        showMonthYearPicker={true}
                    />
                }
                {tab === 2 && <Select
                    options={reportDates}
                    styles={{
                        ...customStyles,
                        menuPortal: (base) => ({...base, zIndex: 9999}),
                    }}
                    key={tab}
                    id={tab}
                    isSearchable={true}
                    value={selectedDate? selectedDate.label : 'null'}
                    className='select_input'
                    placeholder={translations?.['quarterly_reports.index.placeholder.select_date']}
                    onChange={(date) => handleChangeDate(date?.label)}
                />}
            </div>
        </div>
    )
}


export default DateSelector;
